
import ACTS from '../constants'

const defaultStatus = {
    title: '채권채무'
}

export default (state = defaultStatus, action) => {
    switch(action.type) {
        case ACTS.DEBT_SUMMARY:
        return{
            ...state,
            items : action.payload.item
        }        
        default:        
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/debt.js